import { action, observable } from 'mobx';
import QuizItemSettings from './QuizItemSettings';
import { FormCaptchaType } from '../../../captcha/FormCaptcha';

export class CaptchaItemSettings extends QuizItemSettings {
    constructor(s?: Partial<CaptchaItemSettings>) {
        super();
        if (s)
            this.update(s);
    }

    @observable captchaType: FormCaptchaType;
    @observable errorText: string;

    @action update(q: Partial<CaptchaItemSettings>, allowUndefined = false) {
        super.update(q, allowUndefined);
    }

    static build(settings?: Partial<CaptchaItemSettings>) {
        return new CaptchaItemSettings({
            ...QuizItemSettings.default,
            captchaType: FormCaptchaType.Puzzle,
            errorText: '',
            required: true,
            ...settings
        });
    }

    clone() {
        return new CaptchaItemSettings({
            ...this
        });
    }

    static fromJson(json: any) {
        return CaptchaItemSettings.build(json);
    }
}
